export const balance_outstanding = {
    blocking: true,
    content:
      "You have an outstanding balance, please head to the customer service desk.",
    disabled: false,
    thirdPartyId: '',
    trigger:
      "(AFV.Name = 'outstanding_balance' AND TRY_CAST(AFV.value AS DECIMAL) > 0)",
    name: "Balance due",
    predicate: {
      type: "JMESPath",
      expression: "FieldValues.outstanding_balance > `0`"
    }
  }

  export const initialData = {
    blocking: false,
    content: "",
    disabled: false,
    thirdPartyId: "",
    trigger: "",
    name: "",
    predicate: null
  }